const home = {
  header: {
    titleLineOne:
      "Vocabulary, grammar, listening comprehension, expression, and English-speaking culture (CEFR levels A1, A2, B1 and B2)",
    titleLineOneBis: "Mock tests for Ev{'@'}lang and English certifications.",
    titleLineTwo: "Engaging, interactive exercises and lesson sheets",
    titleLineThree: "Suitable for classroom use or individual study",
    links: ["Our team", "How it works", "In the Media", "Contact us"],
  },
  moreInfo: "LEARN MORE",
  gar_notice: "Please access the resources through your ENT.",
  origin_iizenglish: {
    title: "WHY IIZENGLISH ?",
    firstLine: "iizenglish was born from a simple reality: ",
    liOne:
      "Differentiation is essential and teachers need flexible tools to address the diversity of their students’ learning profiles",
    liTwo:
      "Helping students truly retain what they learn remains a constant goal",
    paragraphOne:
      "That’s why we created iizenglish, a simple, intuitive platform designed by teachers for teachers, to make differentiation effortless and boost every student’s progress.",
    paragraphTwo:
      "With smart active repetition, iizenglish transforms practice into a lasting learning experience, where every activity strenghtens understanding and keeps motivation high.",
  },
  offer: {
    title: "Our benefits",
    teacherTitle: "FOR TEACHERS",
    studentTitle: "FOR STUDENTS",
    forTeacherAdvantages: [
      "Create assignments quickly for class or homework from a wide range of exercises",
      "Create flexible learning groups within the same class based on students’ needs or levels",
      "Assign differentiated exercises or adjust the difficulty of the same exercise",
      "Get personalized progress reports",
    ],
    forStudentsAdvantages: [
      "Exercises are automatically corrected and graded",
      "Redo exercises as many times as you like, with new sentences each time.",
      "Visuals and audio support to help memorise vocabulary more effectively",
      "Only the highest score is recorded",
    ],
  },
  plan: {
    allDevice: "AVAILABLE ON PC, TABLET OR SMARTPHONE",
    howItWorks: "ADDITIONAL INFORMATION",
    plans: [
      "ANNUAL SUBSCRIPTION",
      "{price} PER STUDENT / YEAR",
      "DEMO VERSION AVAILABLE",
    ],
  },
  footer: {
    cgu: "GENERAL TERMS AND CONDITIONS",
    legalNotices: "LEGAL NOTICE",
  },
  PrivacyPolicy: {
    title: "PRIVACY POLICY",
    ressourceUrl:
      "https://files.iizenglish.com/prod/ressources/en/2023_11_21_Privacy_Policy.pdf",
  },
};

export default home;
